module.exports = __webpack_public_path__ + "img/biggest-planet.8a001ee5.svg";